import React, { Fragment } from 'react';
import BlockNumber from '../Components/BlockNumber';
import AddressName from '../Components/AddressName';
import Coin from '../Components/Coin';
import NumberFormatter from '../Components/NumberFormatter';
import Muted from '../Components/Muted';
import EtherscanLink from '../Components/EtherscanLink';

export default class MintingRow extends React.Component {
  render () {
    return (
      <Fragment>
        <BlockNumber blockNumber={this.props.coinsMinted.blockNumber}/>
        <AddressName address={this.props.coinsMinted.args.to.toString()}/>
        <Muted content="received&nbsp;"/>
        <Coin coin={this.props.coinsMinted.args.tokens.toNumber()}/>
        <Muted content="total supply&nbsp;"/>
        <NumberFormatter number={this.props.coinsMinted.args.newTotalSupply.toNumber()}/>
        <EtherscanLink txHash={this.props.coinsMinted.transactionHash}/>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/MintingRow.js